<template>
    <button :type="type" :class="[custom_class ? custom_class : 'ml-3', 'primaryButton']">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            custom_class: String
        }
    }
</script>
